import { Td, Tfoot, Tr } from "@chakra-ui/react";
import { flexRender, type HeaderGroup } from "@tanstack/react-table";
import { observer } from "mobx-react-lite";
import type { BodyRow } from "../../types";
import { getColumnMeta, getColumnSizeCssVar } from "../helpers";

type TableFooterProps<Row extends BodyRow> = {
  footerGroups: HeaderGroup<Row>[];
  shouldRender: boolean;
};
export const TableFooter = observer(function TableFooter<Row extends BodyRow>({
  footerGroups,
  shouldRender,
}: TableFooterProps<Row>) {
  if (!shouldRender) return null;

  return (
    shouldRender && (
      <Tfoot>
        {footerGroups.map((footerGroup) => (
          <Tr key={footerGroup.id}>
            {footerGroup.headers.map((header) => {
              const columnMeta = getColumnMeta(header.column.columnDef);
              const columnSizeCssVar = getColumnSizeCssVar(header.column.id);

              return (
                <Td
                  key={header.id}
                  w={`calc(var(${columnSizeCssVar}) * 1px)`}
                  minW={`calc(var(${columnSizeCssVar}) * 1px)`}
                  maxW={`calc(var(${columnSizeCssVar}) * 1px)`}
                  py={columnMeta?.padding ?? "2"}
                  pr="3"
                  pl="3"
                  textAlign={columnMeta?.align}
                  bg="skyLighter"
                  whiteSpace="nowrap"
                >
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.footer,
                        header.getContext(),
                      )}
                </Td>
              );
            })}
          </Tr>
        ))}
      </Tfoot>
    )
  );
});
